var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingRouteStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2571_71148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 6C1.33301 2.96243 3.79544 0.5 6.83301 0.5C9.87057 0.5 12.333 2.96243 12.333 6C12.333 9.03757 9.87057 11.5 6.83301 11.5C3.79544 11.5 1.33301 9.03757 1.33301 6Z",
    stroke: "#DDE0E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2571_71148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.833008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingRouteStep);
export default __webpack_public_path__ + "static/media/pending-route-step.02748771.svg";
export { ForwardRef as ReactComponent };